<div animate.enter="content-enter" class="grid grid-cols-1 lg:grid-cols-3 gap-4">
  <div class="lg:col-span-2">
    <app-project-details [properties]="projectInfo()" />
  </div>
  <div class="lg:col-span-1">
    <app-contact-details [contact]="projectInfo().contact" />
  </div>
</div>
